"use strict";

import Debounce from './src/debounce';
import Form from './src/form';
import Select from './src/select';
import Css from './src/css';
import Ajax from './src/ajax';
import fetchProductPricing from './src/fetchProductPricing';
import productQtyInputEstimate from './src/productQtyInputEstimate';
import FormatDollarAmount from './src/formatDollarAmount';
import Notice from './src/notice';
import Emitter from './src/globalEmitter';

const searchResultsApiUrl = window.location.origin + '/api/v1/search-results';
const cartApiUrl = window.location.origin + '/api/v1/carts';

var quickOrderTypeAhead = {
    typeAheadInput: null,
    typeAheadInputWasFocusedBy: 'tab',
    typeAheadName: '',
    typeAheadClearInputButton: null,
    ajaxRequestResults: {},
    ajaxRequest: null,
    successCallback: function(response){},
    errorCallback: function(status, response){},
    clearInputCallback: function(){},
    init: function(el){
        if(el !== null) {
            this.typeAheadInput = el;
            if (this.typeAheadInput !== null) {
                this.typeAheadName = this.typeAheadInput.getAttribute('data-type-ahead');
                if(this.typeAheadName !== null){
                    this.typeAheadClearInputButton =
                        Select.one('[data-type-ahead-clear-input-for="' + this.typeAheadName + '"]', this.typeAheadInput.form);
                    this.listenForClearInputButtonClick(this.typeAheadClearInputButton);
                }
                this.listenToElementInput(this.typeAheadInput);
            }
        }
    },
    listenToElementInput: function(el){
        var self = this;
        el.addEventListener('keyup', Debounce(function(e) {
            if( el.value ) {
                var charCode = (e.which) ? e.which : e.keyCode
                if (self.ajaxRequest !== null && typeof self.ajaxRequest === 'object')
                    self.ajaxRequest.abort();

                if( charCode !== 9 && charCode !== 40 && charCode !== 38 ) {
                    self.ajaxRequest = Ajax('GET', searchResultsApiUrl + '/' + encodeURIComponent(el.value), {},
                        function (response) {
                            var responseJson = JSON.parse(response);
                            self.ajaxRequestResults = responseJson;
                            self.successCallback(responseJson);
                        }, function (status, response) {
                            self.errorCallback(status, response);
                        }
                    );
                }
            }
            else{
                self.successCallback({});
            }
        }, 300), false);
        el.addEventListener('mousedown', function(e){
            self.typeAheadInputWasFocusedBy = 'mouse';
        }, false);
        el.addEventListener('focus', function(e){
            if( self.typeAheadInputWasFocusedBy == 'tab' || self.typeAheadInputWasFocusedBy == 'mouse' )
                self.resetInputAndClearList();
            self.typeAheadInputWasFocusedBy = 'tab';
        }, false);
    },
    listenForClearInputButtonClick: function(el){
        if(el !== null){
            var self = this;
            el.addEventListener('click', function(e){
                e.preventDefault();
                self.resetInputAndClearList();
            });
        }
    },
    resetInputAndClearList: function(){
        this.typeAheadInput.value = '';
        this.typeAheadInput.focus();
        this.successCallback({});
        this.clearInputCallback();
    }
};


function QuickOrderTypeAheadResultsList(resultsObj){
    this.results = resultsObj || {};
    this.listTopArrow = null;
    this.list = null;
    this.listItems = '';
}

QuickOrderTypeAheadResultsList.prototype = {
    init: function(resultsObj){
        this.results = resultsObj || this.results;
        this.createListTopArrow();
        this.createList();
        this.createListItems();
        this.list.innerHTML = this.listItems;
    },
    createListTopArrow: function(){
        if(this.listTopArrow == null) {
            this.listTopArrow = document.createElement('span');
            Css.addClass(this.listTopArrow, 'quick-order__search-results__list__top-arrow');
        }
    },
    createList: function(){
        if(this.list == null) {
            this.list = document.createElement('ul');
            this.list.setAttribute('data-quick-order-product-id-search-results', '');
            Css.addClass(this.list, 'quick-order__search-results__list');
            this.addListOnClickEvent(this.list);
        }
    },
    createListItems: function(){
        this.listItems = '';
        if(typeof this.results === 'object'){
            if( this.results.hasOwnProperty('noResultsFound') && this.results.noResultsFound === 1 ){
                this.listItems = this.returnNoResultsListItemHtml();
            }
            else if( this.results.length ) {
                for (var i = 0, len = this.results.length; i < len; i++) {
                    this.listItems += this.returnListItemHtml(this.results[i].product_id, this.results[i].name);
                }
            }
        }
    },
    returnListItemHtml: function(productId, name){
        return '<li class="quick-order__search-results__list-item">'
                     + this.returnListItemLinkHtml(productId, name)
                     + '</li>';
    },
    returnListItemLinkHtml: function(productId, name){
        return '<button href="#" class="quick-order__search-results__list-item__button" tabindex="3" data-quick-order-result-button data-product-id="' + productId + '">'
            + '<span class="quick-order__search-results__list-item__link__sku-label">' + productId + '</span>'
            + name
            + '</button>';
    },
    returnNoResultsListItemHtml: function(){
        return '<li class="quick-order__search-results__list-item text__center">'
            + '<strong>No Products Found</strong>'
            + '</li>';
    },
    addListOnClickEvent: function(el){
        var self = this;
        el.addEventListener('click', function(e){
            self.onListClickEvent(e);
        }, false);
    },
    onListClickEvent: function(e){},
    hasListItems: function(){
        return this.listItems !== '';
    }
};


function QuickOrderLineItem(productDetails){
    this.productDetails = productDetails || {};
    this.productPricing = false;
    this.productId = null;
    this.lineItemId = 0;
    this.lineItemElement = null;
    this.productIdElement = null;
    this.qtyElement = null;
    this.qtyInputElement = null;
    this.qtyInputElementQtyInputEstimate = null;
    this.lineItemActionElement = null;
    this.lineItemEstimateElement = null;
    this.lineItemDetailElement = null;
}

QuickOrderLineItem.prototype = {
    init: function(callback){
        var callback = callback || function(){};
        this.productId = this.productDetails.product_id;
        this.lineItemId = this.productId;
        if(this.productId){
            var self = this;
            fetchProductPricing(this.productId, function(pricing){
                if(pricing){
                    self.productPricing = pricing;
                    self.createLineItem();
                    callback();
                }
                else
                    self.error();
            });
        }
    },
    createLineItem: function(){
        this.lineItemElement = document.createElement('li');
        this.lineItemElement.setAttribute('data-quick-order-form-line-item-id',this.lineItemId);
        Css.addClass(this.lineItemElement, 'quick-order__form__line-item__list-item');
        this.createLineItemActionElement();
        this.createProductIdElement();
        this.createLineItemDetailElement();
        this.createQtyElement();
        this.createLineItemEstimateElement();
        this.setLineItemEstimateToDisplayEstimate();
        this.lineItemElement.appendChild(this.lineItemActionElement);
        this.lineItemElement.appendChild(this.productIdElement);
        this.lineItemElement.appendChild(this.qtyElement);
        this.lineItemElement.appendChild(this.lineItemEstimateElement);
        this.lineItemElement.appendChild(this.lineItemDetailElement);
    },
    createProductIdElement: function(){
        this.productIdElement = document.createElement('div');
        this.productIdElement.setAttribute('data-quick-order-form-line-item-product-id',this.productId);
        Css.addClass(this.productIdElement, 'quick-order__form__line-item__product-id__column');
        this.productIdElement.innerHTML = '<a href="#" title="" class="quick-order__form__line-item__product-id__detail-link">' + this.productId + '</a>';
        this.addProductIdEventListener();
    },
    addProductIdEventListener: function(){
        var self = this;
        this.productIdElement.addEventListener('click', function(e){
            self.onLineItemProductIdClickEvent(e);
        }, false)
    },
    onLineItemProductIdClickEvent: function(e){
        e.preventDefault();
        this.toggleLineItemDetail();
    },
    createQtyElement: function(){
        this.qtyElement = document.createElement('div');
        this.qtyElement.setAttribute('data-quick-order-form-line-item-product-id',this.productId);
        Css.addClass(this.qtyElement, 'quick-order__form__line-item__quantity-input__column');

        if(this.productDetails.priced_per === 'PER QUANTITY')
            this.createQtySelectElement();
        else
            this.createQtyInputElement();

        this.qtyElement.appendChild(this.qtyInputElement);
    },
    createQtyInputElement: function(){
        var inputElement = document.createElement('input');
        inputElement.setAttribute('name','qty[]');
        inputElement.setAttribute('type','text');
        inputElement.setAttribute('value','');
        inputElement.setAttribute('maxlength','5');
        inputElement.setAttribute('autocomplete','off');
        inputElement.setAttribute('data-validate','quantity');
        inputElement.setAttribute('data-pid',this.productId);
        inputElement.setAttribute('data-line-item-id',this.lineItemId);
        inputElement.setAttribute('data-minimum',this.productDetails.minimum_qty);
        inputElement.setAttribute('data-multiples-of',this.productDetails.order_in_multiples_of);
        inputElement.setAttribute('required','');
        inputElement.setAttribute('tabindex','1');
        //inputElement.value = this.productDetails.minimum_qty;
        Css.addClass(inputElement, 'form__input');
        this.qtyInputElement = inputElement;
    },
    createQtySelectElement: function(){
        var selectElement = document.createElement('select');
        selectElement.setAttribute('name','qty[]');
        selectElement.setAttribute('data-pid',this.productId);
        selectElement.setAttribute('data-line-item-id',this.lineItemId);
        selectElement.setAttribute('required','');
        selectElement.setAttribute('tabindex','1');
        Css.addClass(selectElement, 'form__input');
        if(typeof this.productPricing === 'object'){
            if(this.productPricing.length){
                var options = '';
                for( var i = 0, len = this.productPricing.length; i < len; i++){
                    options += this.returnQtySelectOption(this.productPricing[i].qty, this.productPricing[i].price);
                }
                selectElement.innerHTML = options;
            }
        }
        this.qtyInputElement = selectElement;
    },
    returnQtySelectOption: function(quantity, price){
        var option = ' <option value="' + quantity +'" ';
            option +=  'data-price="' + price +'" ';
            option +=  'data-qty="' + quantity +'" >';
            option +=  quantity + '</option>';
        return option;
    },
    qtyInputElementType: function(){
        return this.qtyInputElement.type;
    },
    setQtyInputElementToMinimumQty: function(){
        var qtyInputElementType = this.qtyInputElementType();
        if(qtyInputElementType === 'text')
            this.qtyInputElement.value = this.productDetails.minimum_qty;
        else if(qtyInputElementType === 'select-one')
            this.qtyInputElement.selectedIndex = 0;
    },
    createLineItemActionElement: function(){
        this.lineItemActionElement = document.createElement('div');
        this.lineItemActionElement.setAttribute('data-quick-order-form-line-item-actions','');
        Css.addClass(this.lineItemActionElement, 'quick-order__form__actions__column');
        this.lineItemActionElement.innerHTML = '<a href="" title="" class="btn__alert--outline btn--small '
            + 'quick-order__form__actions__link" data-button="remove-line-item">'
            + '<i class="icon-trash quick-order__form__actions__icon"></i></a>';
        this.addLineItemActionEventListener();
    },
    addLineItemActionEventListener: function(){
        var self = this;
        this.lineItemActionElement.addEventListener('click', function(e){
            self.onLineItemActionClickEvent(e);
        }, false)
    },
    createLineItemEstimateElement: function(){
        this.lineItemEstimateElement = document.createElement('div');
        this.lineItemEstimateElement.setAttribute('data-quick-order-form-line-item-estimate','');
        Css.addClass(this.lineItemEstimateElement, 'quick-order__form__estimate__column');
        //this.lineItemEstimateElement.innerHTML = '';
    },
    setLineItemEstimateToDisplayEstimate: function(){
        var displayEstimateElement = this.lineItemEstimateElement;
        this.qtyInputElementQtyInputEstimate = new productQtyInputEstimate(this.qtyInputElement, function(el, estimate){
            if(displayEstimateElement !== null){
                displayEstimateElement.innerHTML =  estimate > 0 ? '$' + FormatDollarAmount(estimate) : '';
            }
        }, this.productPricing);
    },
    createLineItemDetailElement: function(){
        this.lineItemDetailElement = document.createElement('div');
        Css.addClass(this.lineItemDetailElement, 'quick-order__form__line-item__list-item__detail');
        Css.addClass(this.lineItemDetailElement, 'hide');

        var lineItemDetailElementInnerHtml = this.productDetails.name;
        if(this.productDetails.priced_per !== 'PER QUANTITY')
            lineItemDetailElementInnerHtml += '<br>Minimum: <strong>' + this.productDetails.minimum_qty
                + '</strong>&nbsp;&nbsp;Multiples of: <strong>' + this.productDetails.order_in_multiples_of + '</strong>'

        this.lineItemDetailElement.innerHTML = lineItemDetailElementInnerHtml;

        var closeButton = document.createElement('a');
        closeButton.setAttribute('href', '#');
        closeButton.setAttribute('title', 'Close');
        Css.addClass(closeButton, 'quick-order__form__line-item__list-item__detail__close-btn');
        closeButton.innerHTML = 'X';

        var self = this;
        closeButton.addEventListener('click', function(e){
            self.onLineItemCloseDetailClickEvent(e);
        }, false);

        this.lineItemDetailElement.appendChild(closeButton);
    },
    addCloseDetailEventListener: function(el){
        var self = this;
        if(el !== null && this.productIdElement !== null) {
            el.addEventListener('click', function (e) {
                self.onLineItemProductIdClickEvent(e);
            }, false)
        }
    },
    onLineItemCloseDetailClickEvent: function(e){
        e.preventDefault();
        Css.addClass(this.lineItemDetailElement, 'hide');
    },
    toggleLineItemDetail: function(){
        if(this.lineItemDetailElement !== null)
            Css.toggle(this.lineItemDetailElement, 'hide');
    },
    onLineItemActionClickEvent: function(e){
        e.preventDefault();
        var buttonAction = e.target.getAttribute('data-button') || e.target.parentNode.getAttribute('data-button');
        if(buttonAction === 'remove-line-item'){
            this.removeLineItem();
        }
    },
    addLineItem: function(parentElement){
        parentElement.appendChild(this.lineItemElement);
    },
    lineItemIsInDOM: function(){
      return this.lineItemElement.parentNode !== null;
    },
    removeLineItem: function(){
        if(this.lineItemIsInDOM()) {
            this.lineItemElement.parentNode.removeChild(this.lineItemElement);
            this.onRemoveLineItem();
        }
    },
    onRemoveLineItem: function(){},
    error: function(){
        console.log('error creating quick order line item');
    }
};


var quickOrderForm = {
    orderForm: Select.id('quick-order-form'),
    orderFormSubmitButton: Select.one('[data-quick-order-form-submit-button]'),
    orderFormLineItemsElement: null,
    typeAheadForm: Select.id('quick-order-type-ahead'),
    typeAhead: quickOrderTypeAhead,
    typeAheadInputElement: null,
    typeAheadResultsList: new QuickOrderTypeAheadResultsList(),
    typeAheadResultsContainerElement: Select.one('[data-type-ahead-results="quick-order-form"]'),
    typeAheadSearchResults: {},
    quickOrderLineItemsCollection: [],
    orderFormNoticesParentElement: null,
    orderFormSuccessNotice: null,
    orderFormErrorNotice: null,
    noticeAutoRemoveTime: 4000,
    init: function(){
        this.typeAheadInputElement = Select.one('[data-type-ahead="quick-order-form"]');
        if(this.orderForm !== null){
            this.orderFormLineItemsElement = Select.one('[data-quick-order-form-line-items]', this.orderForm);
        }
        var self = this;
        if(this.typeAheadInputElement !== null) {
            this.typeAheadResultsList.onListClickEvent = function(e){
                e.preventDefault();
                var productId = e.target.getAttribute('data-product-id') || e.target.parentNode.getAttribute('data-product-id');
                self.createQuickOrderLineItem(productId);
            };
            this.typeAhead.successCallback = function (response) {
                var searchResults = {};
                if (response.hasOwnProperty('data')) {
                    if (response.data.hasOwnProperty('search_results')) {
                        searchResults = response.data.search_results;
                    }
                }
                self.typeAheadSearchResults = searchResults;
                self.typeAheadResultsList.init(searchResults);
                self.showTypeAheadResultsList();
            };
            this.typeAhead.errorCallback = function (status, response) {
                self.hideTypeAheadResultsList();
            };
            this.onTypeAheadFormSubmit();
            this.typeAhead.init(this.typeAheadInputElement);
        }
        this.initOrderFormListeners();
    },
    showTypeAheadResultsList: function(){
        if(this.typeAheadResultsList.hasListItems()) {
            this.typeAheadResultsContainerElement.appendChild(this.typeAheadResultsList.listTopArrow);
            this.typeAheadResultsContainerElement.appendChild(this.typeAheadResultsList.list);
        }
        else{
            this.hideTypeAheadResultsList();
        }
    },
    hideTypeAheadResultsList: function(){
        if(this.typeAheadResultsList.listTopArrow !== null && this.typeAheadResultsList.listTopArrow.parentNode !== null)
            this.typeAheadResultsList.listTopArrow.parentNode.removeChild(this.typeAheadResultsList.listTopArrow);
        if(this.typeAheadResultsList.list !== null && this.typeAheadResultsList.list.parentNode !== null)
            this.typeAheadResultsList.list.parentNode.removeChild(this.typeAheadResultsList.list);
    },
    initOrderFormListeners: function(){
        var self = this;
        this.orderForm.addEventListener('submit', function(e){
            e.preventDefault();
        }, false);
        this.orderFormSubmitButton.addEventListener('click', function (e) {
            e.preventDefault();
            var formValidation = new Form(self.orderForm);
            formValidation.init();
            if (formValidation.formValid) {
                if( self.orderFormHasLineItems() ){
                    self.addOrderFormLineItemsToCart();
                }
            }
        }, false)
    },
    orderFormHasLineItems: function(){
        var orderFormQtyElements = this.orderForm.elements['qty[]'];
        return typeof orderFormQtyElements !== 'undefined' && typeof orderFormQtyElements === 'object';
    },
    addOrderFormLineItemsToCart: function(){
        var orderFormQtyElements = this.orderForm.elements['qty[]'],
            refreshCartSummary = false,
            lineItemsAddingToCartRequests = 0,
            self = this,
            lineItemAddingToCartCallback = function(success){
                lineItemsAddingToCartRequests--;
                refreshCartSummary = success;
                if(lineItemsAddingToCartRequests === 0 && refreshCartSummary){
                    Emitter.emit('cart-change');
                    self.typeAhead.resetInputAndClearList();
                }
            };

        if(typeof orderFormQtyElements !== 'undefined' && typeof orderFormQtyElements === 'object'){
            if(typeof orderFormQtyElements.length === 'undefined') {//we only have one element - not sure why it does this
                lineItemsAddingToCartRequests++;
                this.addLineItemToCart(orderFormQtyElements, function (success) {
                    lineItemAddingToCartCallback(success);
                })
            }
            else if(typeof orderFormQtyElements.type !== 'undefined' && typeof orderFormQtyElements.options === 'object') {
                // special case for single select input element in list (browser was returning length but it was the options length )
                lineItemsAddingToCartRequests++;
                this.addLineItemToCart(orderFormQtyElements, function (success) {
                    lineItemAddingToCartCallback(success);
                });
            }
            else{ // we have more than one element
                for( var i = 0, len = orderFormQtyElements.length; i < len; i++){
                    lineItemsAddingToCartRequests++;
                    this.addLineItemToCart(orderFormQtyElements[i], function (success) {
                        lineItemAddingToCartCallback(success);
                    });
                }
            }
        }

    },
    addLineItemToCart: function(lineItem, callback){
        if(lineItem !== null){
            var lineItemId = lineItem.getAttribute('data-line-item-id'),
                data = {
                    pid: lineItem.getAttribute('data-pid'),
                    qty: lineItem.value
                },
                self = this;
            if(data.pid && data.qty) {
                var ajaxRequest = Ajax('POST', cartApiUrl, data,
                    function (response) {
                        var responseJson = JSON.parse(response);
                        if(typeof responseJson.data == 'object') {
                            if (responseJson.data.hasOwnProperty('cart_rec_id')) {
                                var productDetails = responseJson.data;
                                if (typeof self.quickOrderLineItemsCollection[data.pid] !== 'undefined') {
                                    productDetails.name = self.quickOrderLineItemsCollection[data.pid].productDetails.name;
                                    self.quickOrderLineItemsCollection[data.pid].removeLineItem();
                                }
                                self.initSuccessNotice('Products successfully added to your cart');
                                self.addSuccessLineItem(productDetails);
                                self.addSuccessNoticeToDOM();
                                callback(true);
                            }
                        }
                    },
                    function (status, response) {
                        callback(false);
                    }
                );
            }
        }
    },
    initSuccessNotice: function(heading){
        if(this.orderFormSuccessNotice == null) {
            this.orderFormSuccessNotice = new Notice('success');
            this.orderFormSuccessNotice.addIconElement();
            this.orderFormSuccessNotice.addHeading(heading);
            this.orderFormSuccessNotice.autoRemoveTime = this.noticeAutoRemoveTime;
        }
    },
    addSuccessNoticeToDOM: function(){
        if(this.orderFormNoticesParentElement == null){
            this.orderFormNoticesParentElement = Select.one('[data-quick-order-form-notices]');
        }
        if(this.orderFormNoticesParentElement !== null) {
            var self = this;
            this.orderFormSuccessNotice.addNoticeToDOM(this.orderFormNoticesParentElement);
            this.orderFormSuccessNotice.addRemoveNoticeFromDOMTimeout(function(){
                self.orderFormSuccessNotice = null;
            });
        }
    },
    addSuccessLineItem: function(productDetails){
        if(this.orderFormSuccessNotice !== null){
            this.orderFormSuccessNotice.addListItem(productDetails.product_id + ' - ' + productDetails.name);
        }
    }
    ,
    addErrorNotice: function(){

    },
    onTypeAheadFormSubmit: function(){
        if(this.typeAheadForm !== null) {
            this.typeAheadForm.addEventListener('submit', function (e) {
                e.preventDefault();
            }, false);
        }
    },
    createQuickOrderLineItem: function(productId){
        if( typeof this.quickOrderLineItemsCollection[productId] !== 'undefined'){
            if(!this.quickOrderLineItemsCollection[productId].lineItemIsInDOM())
                this.quickOrderLineItemsCollection[productId].addLineItem(this.orderFormLineItemsElement);
            /*if(this.quickOrderLineItemsCollection[productId].qtyInputElement.value == ''
                || this.quickOrderLineItemsCollection[productId].qtyInputElement.value < 1
            ) {
                this.quickOrderLineItemsCollection[productId].setQtyInputElementToMinimumQty();
                if (this.quickOrderLineItemsCollection[productId].qtyInputElementQtyInputEstimate !== null
                    || typeof this.quickOrderLineItemsCollection[productId].qtyInputElementQtyInputEstimate !== 'undefined'
                ) {
                    this.quickOrderLineItemsCollection[productId].qtyInputElementQtyInputEstimate.triggerChangeEvent();
                }
            }*/
            this.quickOrderLineItemsCollection[productId].qtyInputElement.focus();
            this.setOrderFormSubmitButtonState();
        }
        else{
            var productDetails = null;
            if(typeof this.typeAheadSearchResults == 'object'){
                if(this.typeAheadSearchResults.length){
                    for( var i = 0, len = this.typeAheadSearchResults.length; i < len; i++){
                        if(this.typeAheadSearchResults[i].product_id == productId) {
                            productDetails = this.typeAheadSearchResults[i];
                            break;
                        }
                    }
                }
            }
            if(productDetails) {
                this.quickOrderLineItemsCollection[productId] = new QuickOrderLineItem(productDetails);
                var orderFormLineItemsElement = this.orderFormLineItemsElement,
                    quickOrderLineItem = this.quickOrderLineItemsCollection[productId],
                    self = this;

                quickOrderLineItem.init(function(){
                    quickOrderLineItem.addLineItem(orderFormLineItemsElement);
                    quickOrderLineItem.qtyInputElement.focus();
                    self.setOrderFormSubmitButtonState();
                });
                quickOrderLineItem.onRemoveLineItem = function(){
                    self.setOrderFormSubmitButtonState();
                };
            }
        }
    },
    setOrderFormSubmitButtonState: function(){
        if(this.orderFormHasLineItems())
            this.enableOrderFormSubmitButton();
        else
            this.disableOrderFormSubmitButton();
    },
    enableOrderFormSubmitButton: function(){
        Css.removeClass(this.orderFormSubmitButton, 'btn--disabled');
        this.orderFormSubmitButton.removeAttribute('disabled');
    },
    disableOrderFormSubmitButton: function(){
        Css.addClass(this.orderFormSubmitButton, 'btn--disabled');
        this.orderFormSubmitButton.setAttribute('disabled', '');
    }
};

quickOrderForm.init();
var autoFocusElement = Select.one('[autofocus]');

setTimeout(function() {
    autoFocusElement.blur();
    quickOrderForm.typeAheadInputElement.focus();
}, 100);


/**
 *  @todo clean up the arrow key test function
 */


var testArrowKeys = function(){
    var el = Select.one('[data-quick-order-type-ahead-form]'),
        resultsListing = Select.one('[data-type-ahead-results]', el);
    if(el !== null){
        el.addEventListener('keydown',function(e) {
            var activeEl = null,
                parentEl = null,
                charCode = (e.which) ? e.which : e.keyCode;
            switch(charCode) {
                case 38: //up
                    e.stopPropagation();
                    e.preventDefault();
                    activeEl = document.activeElement;
                    if(activeEl.hasAttribute('data-quick-order-result-button')){
                        parentEl = activeEl.parentNode;
                        if( parentEl !== null ){
                            if( parentEl.previousElementSibling !== null ){
                                var previousButton = Select.one('[data-quick-order-result-button]', parentEl.previousElementSibling);
                                if( previousButton !== null )
                                    previousButton.focus();
                            }
                            else if( el.elements['product_id'] !== null ) {
                                quickOrderTypeAhead.typeAheadInputWasFocusedBy = 'js';
                                el.elements['product_id'].focus();
                            }
                        }
                    }
                    break;
                case 40: //down
                    e.stopPropagation();
                    e.preventDefault();
                    activeEl = document.activeElement;
                    if(activeEl.hasAttribute('data-quick-order-result-button')) {
                        parentEl = activeEl.parentNode;
                        if (parentEl !== null) {
                            if (parentEl.nextElementSibling !== null) {
                                var nextButton = Select.one('[data-quick-order-result-button]', parentEl.nextElementSibling);
                                if (nextButton !== null)
                                    nextButton.focus();
                            }
                            else if( el.elements['product_id'] !== null ) {
                                quickOrderTypeAhead.typeAheadInputWasFocusedBy = 'js';
                                el.elements['product_id'].focus();
                            }
                        }
                    }
                    else{
                        var firstButton = Select.one('[data-quick-order-result-button]', el);
                        if( firstButton !== null )
                            firstButton.focus();
                    }
                    break;
                default:
                    return true;
            }
        });
    }
};

testArrowKeys();

window.addEventListener("beforeunload", function (e) {
    if (!quickOrderForm.orderFormHasLineItems()) {
        return undefined;
    }
    var confirmationMessage = 'It looks like you have chosen items to add to your cart. '
        + 'If you leave before adding them to your cart, your changes will be lost.';

    (e || window.event).returnValue = confirmationMessage; //Gecko + IE
    return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
});
